var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBga(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 2950 1707.2",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_etv742x7IiNKRKnwGEtYEMvb7BCpGorP"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2950,
    height: 1707.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_etv742x7IiNKRKnwGEtYEMvb7BCpGorP)",
    transform: "matrix(1, 0, 0, 1, -188.758585, -80.372045)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_ZDYMEOsu4YpWiWrpMPl5EhbxyObXZuLN)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 0,
    width: 3183.844,
    height: 2001.673,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(254, 249, 231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -116.863 1901.252 C 451.306 1905.549 695.482 1832.522 992.558 1706.646 C 1331.957 1562.837 1478.065 1351.393 1516.031 959.169 C 1548.812 620.507 1561.001 196.319 1537.961 -158.399 C 1513.645 -532.767 1452.615 -974.541 1245.837 -1227.024 C 1037.567 -1481.33 699.605 -1285.903 427.16 -1379.562 C 168.851 -1468.361 -49.142 -1866.044 -303.776 -1759.737 C -559.11 -1653.138 -589.845 -1177.327 -749.239 -888.431 C -893.108 -627.674 -1114.053 -451.564 -1194.493 -145.337 C -1284.507 197.341 -1366.524 612.779 -1224.857 922.204 C -1082.564 1232.997 -723.833 1163.102 -500.557 1370.341 C -265.528 1588.488 -172.751 1897.531 116.863 1901.252 Z",
    fill: "rgb(82, 88, 45)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBga);
export default __webpack_public_path__ + "static/media/bga.435b409199db76d48bd22c8f9601969e.svg";
export { ForwardRef as ReactComponent };